import styled from "styled-components";

const StyledHeader = styled.h5`
    color: #3d6c4d;
    font-family: "Roboto","serif";
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    margin-top: 100px;
    margin-bottom: -40px;
`;


function GreenHeader({title}) {
  return (
          <StyledHeader>
              {title}
          </StyledHeader>
  );
}

export default GreenHeader;
